import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Box, Button, FormControl, Grid, IconButton, InputAdornment, TextField, Typography, Snackbar } from '@mui/material';
import React, { useEffect, useState } from 'react'
// import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom'
import ErrorAlert from '../../Layouts/ErrorAlert'
import { isValidEmail } from '../../libs/utils'
import '../../theme/App.css'
import ClearIcon from '@mui/icons-material/Clear'
import { config } from '../../config'
import { PublicClientApplication } from '@azure/msal-browser'
import { useSelector } from 'react-redux'
import ReusableSnackbar from '../../Layouts/ReusableSnackbar'
// import { selectNecessaryProps } from '../register/RegisterPage';

function LoginPage(props) {
  const { search } = useLocation()
  const query = new URLSearchParams(search)
  const location = useLocation()
  const navigate = useNavigate()
  // const navigate = useNavigate();
  // const dispatch = useDispatch();
  // const { msgTitle, msgText } = useSelector(selectNecessaryProps);
  const loggedIn = useSelector((state) => state.auth.isAuthenticated)
  const [showError, setShowError] = useState(false)
  const [username, setUsername] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [password, setPassword] = useState('')
  const [isIncorrectEmail, setIsIncorrectEmail] = useState(false)
  const [emailAddress, setEmailAddress] = useState('')
  const [otpMessage, setOtpMessage] = useState(false)
  const { loginError: error, isAuthenticated, msgText, msgTitle } = props

  // useEffect(() => {
  //   if (error) {
  //     setShowError(true)
  //   }
  // }, [error])

  // useEffect(() => {
  //   console.log({ loggedIn })
  //   if (loggedIn) navigate('/application-management')
  // }, [loggedIn])

  useEffect(() => {
    if (props.redirect === 'otp') {
      setOtpMessage(true)
    }
  }, [props.redirect])

  const handleClose = (event, reason) => {
    setOtpMessage(false)
  }

  const action = (
    <Button onClick={handleClose} color="secondary" size="small">
      <ClearIcon />
    </Button>
  )
  const handleClickShowPassword = () => {
    setShowPassword(true)
  }
  const handleMouseDownPassword = (event) => {
    setShowPassword(false)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const data = {
      login: username,
      arcPassword: password,
      productId: query.get('productId') || location.state?.productId || 81401
    }
    const personaData = {
      login: username,
    }
    props.login(data)
    props.getUserPersona(personaData)
  }

  const handleEmailChange = (event) => {
    if (!isValidEmail(event.target.value)) {
      setIsIncorrectEmail(true)
    } else {
      setUsername(event.target.value)
      setIsIncorrectEmail(false)
    }
    setEmailAddress(event.target.value)
  }

  const handleSSOClick = (e) => {
    props.ssoLogin()
  }

  // const publicClientApplication = new PublicClientApplication({
  //   auth: {
  //     clientId: config.appId,
  //     redirectUri: config.redirectUri,
  //     authority: config.authority
  //   },
  //   cache: {
  //     cacheLocation: "sessionStorage",
  //     storeAuthStateInCookie: true
  //   }
  // });
  // const loginWithSSO = async() => {
  //   try{
  //     await publicClientApplication.loginPopup(
  //       {
  //         scopes: config.scopes,
  //         prompt: "select_account"
  //       }
  //     )

  //   }
  //   catch(err){
  //     setShowError(true);
  //   }
  // }
  // useEffect(()=>{
  //   const data={
  //     email: "aarona@yopmail.com"
  //   }
  //   props.generateOTP(data)
  // },[])

  return (
    <>
      {/* <ErrorAlert
        showError={showError}
        setShowError={setShowError}
        msgTitle={msgTitle || 'Login failed.'}
        messageText={msgText || 'Incorrect email or password.'}
      /> */}
      {error && (
        <ReusableSnackbar
          title={msgTitle || 'Login failed.'}
          message={msgText || 'Incorrect email or password.'}
          alertType="warning"
        />
      )}
      {
        <Snackbar
          open={otpMessage}
          autoHideDuration={10000}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          sx={{
            '&.MuiSnackbar-anchorOriginTopRight': { top: '100px' },
          }}
          message="We have sent a one-time password to your email. Please login using this password, then follow instructions to set your own."
          action={action}
        />
      }
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          flexDirection: 'column',
        }}
      >
        <Box sx={homeStyle.blueBox}>
          <Box sx={homeStyle.loginHeader}>Welcome</Box>
          <Box sx={homeStyle.loginSubHeader}>Log in to your Life Insurance Applications Portal </Box>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth={true}>
                <TextField
                  InputLabelProps={{
                    shrink: true,
                    sx: {
                      '&.MuiInputLabel-shrink': {
                        backgroundColor: '#F5F7FF',
                      },
                    },
                  }}
                  variant="outlined"
                  className="white-box"
                  id="outlined-email"
                  label={<Box required>Email</Box>}
                  fullWidth
                  error={isIncorrectEmail}
                  placeholder="email@email.com"
                  onChange={handleEmailChange}
                  value={emailAddress}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth={true}>
                <TextField
                  InputLabelProps={{
                    shrink: true,
                    sx: {
                      '&.MuiInputLabel-shrink': {
                        backgroundColor: '#F5F7FF',
                      },
                    },
                  }}
                  className="white-box"
                  variant="outlined"
                  id="outlined-password-input"
                  label={<Box required>{'  Password  '}</Box>}
                  type={showPassword ? 'text' : 'password'}
                  fullWidth
                  placeholder="*********"
                  autoComplete="current-password"
                  onChange={(e) => {
                    setPassword(e.target.value)
                  }}
                  value={password}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={2} style={{ margin: '-25px' }}>
            {/* <Grid container item xs={12} justifyContent="flex-start">
              <Button sx={homeStyle.belowPasswordGridText} onClick={handleSSOClick}>
                Sign in as Afficiency Employee
              </Button>
            </Grid> */}
            <Grid container item xs={6} justifyContent="flex-start">
              <Button
                sx={homeStyle.belowPasswordGridText}
                LinkComponent={Link}
                to={{ pathname: '/forgot-password', search }}
              >
                Forgot your password?
              </Button>
            </Grid>
            <Grid container item xs={6} justifyContent="flex-end">
              <Button sx={homeStyle.belowPasswordGridText} LinkComponent={Link} to={{ pathname: '/register', search }}>
                Don't have an account?
              </Button>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Button
                sx={homeStyle.updateInfoButton}
                onClick={(e) => handleSubmit(e)}
                disabled={!Boolean(username && password)}
              >
                <Typography sx={homeStyle.updateInfoText}>Login</Typography>
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  )
}
export default LoginPage;

const homeStyle = {
  updateInfoText: {
    //color: "#FFFFFF",
    fontFamily: "Roboto",
    fontStyle: "bold",
    fontWeight: 800,
    fontSize: "14px",
    lineHeight: "20px",
    textAlign: "center",
    letterSpacing: "0.1px",
  },
  belowPasswordGridText: {
    textTransform: "none",
    fontSize: { lg: "15px", md: "13px", sm: "12px", xs: "10px" },
  },
  updateInfoButton: {
    justifyContent: "center",
    textTransform: "none",
    py: "10px",
    width: { lg: "35%", md: "35%", sm: "35%", xs: "100%" },
    height: "40px",
    mt: "15px",
    backgroundColor: "#3C4FB9",
    color: "white",
    borderRadius: "100px",
    flex: "none",
    order: 2,
    flexGrow: 0,
    "&:hover": {
      backgroundColor: "#9BA5DF",
      color: "#36414E",
    },
    "&:disabled": {
      backgroundColor: "#C4CAF1",
      color: "white",
      textTransform: "none",
    },
  },
  noBeneAvailDetailText: {
    width: { lg: "740px", md: "666px", xs: "311px" },
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    textAlign: "left",
    alignItems: "center",
    color: "#56677B",
    flex: "none",
    alignSelf: "stretch",
    flexGrow: 0,
  },

  loginHeader: {
    width: { lg: "740px", md: "666px", sm: "666px", xs: "250px" },
    height: { lg: "32px", md: "32px", sm: "20px", xs: "30px" },
    fontFamily: "Roboto Slab",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: { lg: "34px", md: "32px", xs: "28px" },
    lineHeight: "32px",
    textAlign: "center",
    whiteSpace: "normal",
    color: "#003C4D",
    flex: "none",
    flexGrow: 0,
  },

  loginSubHeader: {
    width: { lg: "740px", md: "666px", sm: "666px", xs: "250px" },
    height: { lg: "32px", md: "32px", sm: "20px", xs: "60px" },
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontSize: { lg: "18px", md: "16px", xs: "12px" },
    lineHeight: "32px",
    textAlign: "center",
    whiteSpace: "normal",
    color: "#003C4D",
    flex: "none",
    flexGrow: 0,
  },
  benefitsAvaillibilityTextFrame: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: "0px",
    gap: "12px",
    width: { lg: "740px", md: "666px", xs: "311px" },
    height: { lg: "92px", md: "92px", xs: "140px" },
    flex: "none",
    order: 2,
    alignSelf: "center",
    flexGrow: 0,
  },

  blueBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    pt: { lg: "52px", md: "52px", sm: "39px", xs: "24px" },
    pr: { lg: "52px", md: "52px", sm: "39px", xs: "16px" },
    pb: { lg: "52px", md: "52px", sm: "39px", xs: "24px" },
    pl: { lg: "52px", md: "52px", sm: "39px", xs: "16px" },
    gap: { lg: "32px", md: "32px", sm: "32px", xs: "20px" },
    width: { lg: "544px", md: "570px", sm: "500px", xs: "300px" },
    stretch: { height: "100%" },
    background: "#F5F7FF",
    borderRadius: "8px",
    flex: "none",
    order: 1,
    alignSelf: "center",
    flexGrow: 0,
  },
  main: {
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
    alignItems: "center",
    background: "#FFFFFF",
    flex: "none",
    order: 1,
    flexGrow: { lg: 1, md: 0, xs: 0 },
  },
  container: (theme) => ({
    display: "flex",
  }),
  item: (theme) => ({
    border: "1px solid blue",
  }),
  itemFlexGrow: (theme) => ({
    flexGrow: 1,
    border: "1px solid red",
  }),
};
